export default [
    /*{
        id: 12,
        name: '缴费情况统计',
        icon: 'el-icon-s-data',
        show: false,
        component: "ModuleTwelve",
        className: "s-item-large",
    },*/
    {
        id: 1,
        name: '各院系新生人数',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleOne",
        className: "s-item-large",
    },
    {
        id: 2,
        name: '新生报到人数',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleTwo",
        className: "",
    },
    {
        id: 4,
        name: '新生男女比例',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleFour",
        className: "",
    },
    {
        id: 6,
        name: '预报到事项完成人数',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleSix",
        className: "",
    },
    /*{
        id: 6,
        name: '新生专业调整情况',
        icon: 'el-icon-s-data',
        component: "ModuleSix",
        show: true,
        className: "",
    },*/
    {
        id: 3,
        name: '预报到统计',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleThree",
        className: "s-item-large",
    },

    /*{
        id: 7,
        name: '各院系新生专业调整情况',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleSeven",
        className: "s-item-large",
    },*/
    {
        id: 5,
        name: '报到行程统计',
        icon: 'el-icon-s-data',
        show: true,
        component: "ModuleFive",
        className: "s-item-large",
    },

]
